export default __webpack_public_path__ + "static/media/result1.7f89544e.jpg";